var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-col",
    {
      staticClass: "ma-0 pa-0 pl-5 pr-5 pb-5 mb-5",
      staticStyle: { "border-bottom": "1px solid #4C4C4C" },
      attrs: { cols: "12" },
    },
    [
      _c(
        "v-row",
        {
          staticClass: "ma-0 pa-0 mt-2 mb-2",
          attrs: { align: "center", justify: "space-between" },
        },
        [
          _c(
            "v-row",
            { staticClass: "ma-0 pa-0", attrs: { align: "center" } },
            [
              _c(
                "v-col",
                {
                  staticClass: "ma-0 pa-0 ml-5",
                  staticStyle: { "font-weight": "bold" },
                  attrs: { cols: "auto", align: "left" },
                },
                [_vm._v(" " + _vm._s(_vm.store.customerName) + " ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.cardLoading
        ? [
            _c(
              "v-row",
              { staticClass: "ma-0 pa-0", attrs: { align: "center" } },
              [
                _c(
                  "v-col",
                  { staticClass: "ma-0 pa-0", attrs: { cols: "3" } },
                  [
                    _c("v-skeleton-loader", {
                      attrs: {
                        boilerplate: false,
                        elevation: "0",
                        dark: "",
                        type: "image",
                        width: "100%",
                        height: "11rem",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "v-col",
                  { staticClass: "ma-0 pa-0 pl-4", attrs: { cols: "9" } },
                  [
                    _c("v-skeleton-loader", {
                      attrs: {
                        boilerplate: false,
                        elevation: "0",
                        dark: "",
                        type: "image",
                        width: "100%",
                        height: "11rem",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        : [
            _c(
              "v-row",
              { staticClass: "ma-0 pa-0 pl-5", attrs: { align: "start" } },
              [
                _vm.store.numberOfUas > 0
                  ? _c(
                      "v-col",
                      {
                        staticClass: "ma-0 pa-0",
                        class: { "pr-4": _vm.store.storeCameras.length > 0 },
                        attrs: { cols: _vm.getColsNum("analysis") },
                      },
                      [
                        _c(
                          "v-col",
                          {
                            staticClass: "ma-0 pa-0",
                            staticStyle: { cursor: "pointer" },
                            attrs: { id: "data_box", cols: "12" },
                            on: {
                              click: function ($event) {
                                return _vm.$emit("analyze-click", _vm.store)
                              },
                            },
                          },
                          [
                            _c(
                              "v-col",
                              {
                                staticClass: "ma-0 pa-3 pl-5 pr-5",
                                attrs: { cols: "12" },
                              },
                              [
                                _c(
                                  "v-col",
                                  {
                                    staticClass: "ma-0 pa-0 mb-1",
                                    attrs: { cols: "12" },
                                  },
                                  [
                                    _c(
                                      "v-row",
                                      {
                                        staticClass: "ma-0 pa-0",
                                        staticStyle: { "font-weight": "bold" },
                                        attrs: {
                                          align: "center",
                                          justify: "space-between",
                                        },
                                      },
                                      [
                                        _c(
                                          "v-col",
                                          {
                                            staticClass: "ma-0 pa-0",
                                            attrs: {
                                              id: "data_sub_title",
                                              cols: "auto",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.tsc("last30DaysVisitors")
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "v-col",
                                          {
                                            staticClass: "ma-0 pa-0",
                                            attrs: { cols: "auto" },
                                          },
                                          [
                                            _c(
                                              "v-row",
                                              {
                                                staticClass: "ma-0 pa-0",
                                                staticStyle: {
                                                  color: "#008DD0",
                                                  "font-size": "0.8rem",
                                                },
                                                attrs: { align: "center" },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.tsc("viewAnalyze")
                                                    ) +
                                                    " "
                                                ),
                                                _c("v-img", {
                                                  staticClass: "ma-0 pa-0 ml-2",
                                                  attrs: {
                                                    "max-height": "0.8rem",
                                                    "max-width": "0.8rem",
                                                    src: require("@/assets/images/blue_right_icon.png"),
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-col",
                                  {
                                    staticClass: "ma-0 pa-0",
                                    attrs: {
                                      id: "data_people_box",
                                      cols: "12",
                                    },
                                  },
                                  [
                                    _c(
                                      "v-row",
                                      {
                                        staticClass: "ma-0 pa-0",
                                        attrs: { align: "center" },
                                      },
                                      [
                                        _c(
                                          "v-col",
                                          {
                                            staticClass: "ma-0 pa-1",
                                            attrs: { cols: "6" },
                                          },
                                          [
                                            _c(
                                              "v-col",
                                              {
                                                staticClass: "ma-0 pa-0 pl-2",
                                                attrs: {
                                                  id: "data_sub_title",
                                                  cols: "12",
                                                  align: "left",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(_vm.tsc("all")) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "v-col",
                                              {
                                                staticClass: "ma-0 pa-0 pl-2",
                                                attrs: {
                                                  id: "data_count",
                                                  cols: "12",
                                                  align: "left",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.totalCount.total +
                                                        _vm.tsc("peopleCount")
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-col",
                                          {
                                            staticClass: "ma-0 pa-1",
                                            attrs: { cols: "6" },
                                          },
                                          [
                                            _c(
                                              "v-col",
                                              {
                                                staticClass: "ma-0 pa-0 pl-2",
                                                attrs: {
                                                  id: "data_sub_title",
                                                  cols: "12",
                                                  align: "left",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.tsc("faceRecognition")
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "v-col",
                                              {
                                                staticClass: "ma-0 pa-0 pl-2",
                                                attrs: {
                                                  id: "data_count",
                                                  cols: "12",
                                                  align: "left",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.totalCount.known +
                                                        _vm.tsc("peopleCount")
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "v-col",
                              {
                                staticClass: "ma-0 pa-0 pr-2 pb-3",
                                staticStyle: { position: "relative" },
                                attrs: { cols: "12" },
                              },
                              [
                                _c("BarChart", {
                                  attrs: {
                                    "chart-data": _vm.visitorData,
                                    options: _vm.chartOptions,
                                    height: 75,
                                  },
                                }),
                                _vm.hourlyFetched &&
                                _vm.visitorData.datasets[0].data.length == 0
                                  ? _c(
                                      "v-col",
                                      {
                                        staticClass: "ma-0 pa-0",
                                        attrs: { id: "no_data", cols: "12" },
                                      },
                                      [
                                        _vm._v(
                                          " " + _vm._s(_vm.t("noData")) + " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.store.storeCameras.length > 0 &&
                _vm.authorities.GET_RECORDING_SUB_BRANCH
                  ? _c(
                      "v-col",
                      {
                        staticClass: "ma-0 pa-0",
                        attrs: { cols: _vm.getColsNum("camera") },
                      },
                      [
                        _c(
                          "v-col",
                          {
                            staticClass: "ma-0 pa-0",
                            staticStyle: { cursor: "pointer" },
                            attrs: { id: "data_box", cols: "12" },
                            on: {
                              click: function ($event) {
                                return _vm.$emit("cctv-click", _vm.store)
                              },
                            },
                          },
                          [
                            _c(
                              "v-col",
                              {
                                staticClass: "ma-0 pa-3 pl-5 pr-5 pb-4",
                                attrs: { cols: "12" },
                              },
                              [
                                _c(
                                  "v-row",
                                  {
                                    staticClass: "ma-0 pa-0 mb-1",
                                    staticStyle: { "font-weight": "bold" },
                                    attrs: {
                                      align: "center",
                                      justify: "space-between",
                                    },
                                  },
                                  [
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "ma-0 pa-0",
                                        attrs: {
                                          id: "data_sub_title",
                                          cols: "auto",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " + _vm._s(_vm.tsc("camera")) + " "
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "ma-0 pa-0",
                                        attrs: { cols: "auto" },
                                      },
                                      [
                                        _c(
                                          "v-row",
                                          {
                                            staticClass: "ma-0 pa-0",
                                            staticStyle: {
                                              color: "#008DD0",
                                              "font-size": "0.8rem",
                                            },
                                            attrs: { align: "center" },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(_vm.tsc("viewCameras")) +
                                                " "
                                            ),
                                            _c("v-img", {
                                              staticClass: "ma-0 pa-0 ml-2",
                                              attrs: {
                                                "max-height": "0.8rem",
                                                "max-width": "0.8rem",
                                                src: require("@/assets/images/blue_right_icon.png"),
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-row",
                                  {
                                    staticClass: "ma-0 pa-0",
                                    staticStyle: { "min-width": "0" },
                                  },
                                  [
                                    _c(
                                      "v-row",
                                      {
                                        staticClass: "ma-0 pa-0",
                                        staticStyle: {
                                          "min-width": "0",
                                          width: "100%",
                                        },
                                        attrs: { align: "center" },
                                      },
                                      _vm._l(
                                        _vm.displayCameras,
                                        function (camera, idx) {
                                          return _c(
                                            "v-col",
                                            {
                                              key: idx,
                                              staticClass:
                                                "ma-0 pa-0 pr-1 pb-1",
                                              staticStyle: { "min-width": "0" },
                                              attrs: { cols: "3" },
                                            },
                                            [
                                              camera.streamAble == false
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass: "ma-0 pa-0",
                                                      staticStyle: {
                                                        height: "8rem",
                                                        "line-height": "8rem",
                                                        "text-align": "center",
                                                        background: "grey",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "p",
                                                        {
                                                          staticStyle: {
                                                            "white-space":
                                                              "pre-wrap",
                                                            "font-size":
                                                              "0.85rem",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.t("offline")
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  )
                                                : camera.thumbnail != undefined
                                                ? _c(
                                                    "div",
                                                    [
                                                      _c(
                                                        "v-img",
                                                        {
                                                          staticClass:
                                                            "ma-0 pa-0",
                                                          staticStyle: {
                                                            background: "grey",
                                                          },
                                                          attrs: {
                                                            height: "8rem",
                                                            "max-width": "100%",
                                                            src: camera.thumbnail,
                                                          },
                                                          on: {
                                                            error: function (
                                                              $event
                                                            ) {
                                                              return _vm.thumbnailError(
                                                                "no_data_box_" +
                                                                  camera.unisCustomerCd +
                                                                  "_" +
                                                                  idx
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "v-col",
                                                            {
                                                              staticClass:
                                                                "ma-0 pa-0 no_data_box_style",
                                                              attrs: {
                                                                id:
                                                                  "no_data_box_" +
                                                                  camera.unisCustomerCd +
                                                                  "_" +
                                                                  idx,
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    _vm.t(
                                                                      "thumbnailError"
                                                                    )
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _c(
                                                    "div",
                                                    {
                                                      staticClass: "ma-0 pa-0",
                                                      staticStyle: {
                                                        height: "8rem",
                                                        "line-height": "8rem",
                                                        "text-align": "center",
                                                        background: "grey",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "p",
                                                        {
                                                          staticStyle: {
                                                            "white-space":
                                                              "pre-wrap",
                                                            "font-size":
                                                              "0.85rem",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.t(
                                                                "notStreaming"
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                            ]
                                          )
                                        }
                                      ),
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }